import React from 'react';
import { Alert, Button, Text, VStack } from 'native-base';
import { useQuery } from '@apollo/client';
import { graphql } from '../../../__generated__';
import { Fulfillment } from '../../../__generated__/graphql';
import Loading from '../../../Common/components/Loading';

export const Label = ({ order, book }: { order: Fulfillment; book: () => void }) => {
  const { data, refetch, loading } = useQuery(
    graphql(
      `
        query deliveryLabel($id: ID) {
          deliveryLabel(id: $id)
        }
      `,
    ),
    {
      variables: { id: order.id },
    },
  );

  const tryLabelAgain = async () => {
    await refetch();
  };

  const labelURL = data?.deliveryLabel;

  if (loading) return <Loading />;

  return (
    <>
      {!labelURL && (
        <VStack space={2}>
          <Alert status={'error'}>
            The label is not available yet from the carrier. Click below to retry in a few moments.
          </Alert>
          <Button isLoading={loading} onPress={() => tryLabelAgain()}>
            Retry
          </Button>
        </VStack>
      )}

      {labelURL && (
        <VStack space={2}>
          <Text fontWeight={600} fontSize={'lg'}>
            Label Generated
          </Text>

          <Alert status={'info'}>When labelled ensure you book for pickup!</Alert>

          <Button onPress={book}>Book For Pickup</Button>

          <iframe src={labelURL} style={{ border: 'none', height: '600px' }} />
        </VStack>
      )}
    </>
  );
};
